import Share from "./share_controller"

export default class extends Share {

    static windowName = "Facebook"

    get urlParameters(){
        const params = new URLSearchParams()
        params.append("u", this.data.get("url"))
        return `?${params.toString()}`
    }

}